import { PlansService } from '@/services/api/plans.service';
import { CommonModule } from '@angular/common';
import { Component, effect, EventEmitter, input, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { Plan } from 'src/app/models/plan.model';

@Component({
    selector: 'app-plan-selector',
    imports: [
        TableModule,
        InputTextModule,
        ButtonModule,
        InputNumberModule,
        InputNumberModule,
        FormsModule,
        CommonModule
    ],
    template: `
        <div class="flex justify-content-center align-items-center mb-4 gap-2">
    </div>
    <p-table #planTable
    [value]="getPlans()" 
    [selectionMode]="multiple ? 'multiple' : 'single'" 
    [(selection)]="selectedPlans"  dataKey="PlanID" 
    [scrollable]="true" 
    scrollHeight="70vh"
    [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="caption">
        <div class="flex">
                <input 
                    pInputText 
                    type="text"
                    [(ngModel)]="searchTerm"
                    (input)="filterPlans()" 
                    placeholder="Search keyword" />
        </div>
    </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 4rem" *ngIf="multiple"><p-tableHeaderCheckbox /></th>
                <th>Name</th>
                <th>Size</th>
                <th>Collection</th>
                <th>Style</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-plan>
            
            <tr *ngIf="multiple">
                <td>
                    <p-tableCheckbox [value]="plan" />
                </td>
                <td>{{ plan.Family }}</td>
                <td>{{ plan.Size }}</td>
                <td>{{ plan.Collection }}</td>
                <td>{{ plan.Styles.StyleName }}</td>
            </tr>
            <tr [pSelectableRow]="plan" *ngIf="!multiple">
                <td>{{ plan.Family }}</td>
                <td>{{ plan.Size }}</td>
                <td>{{ plan.Collection }}</td>
                <td>{{ plan.Styles.StyleName }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="footer"> 
            <tr *ngIf="multiple">
                <td colspan="2">
                    <span>{{selectedPlans.length}} Selected</span>
                </td>
            <td colspan="2">
                <label  *ngIf="priceMode" for="price">Price</label>
                <p-inputNumber 
                inputId="price" 
                [(ngModel)]="currentPrice"
                mode="decimal" 
                [minFractionDigits]="0" 
                [maxFractionDigits]="2" 
                [showButtons]="false" 
                *ngIf="priceMode"/>
            </td>
                <td colspan="1">
                    <p-button label="Select" (onClick)="onSelectPlans()" />
                </td>
            </tr>
            <tr *ngIf="!multiple">
                <td colspan="3">
                    <span>{{selectedPlans.length}} Selected</span>
                    <label  *ngIf="priceMode" for="price">Price</label>
                <p-inputNumber 
                inputId="price" 
                [(ngModel)]="currentPrice" 
                mode="decimal" 
                [minFractionDigits]="0" 
                [maxFractionDigits]="2" 
                [showButtons]="false" 
                *ngIf="priceMode"/>
                </td>
                    <td colspan="1">
                        <p-button label="Select" (onClick)="onSelectPlans()" />
                    </td>
                </tr>
        </ng-template>
    </p-table>
    `
})
export class PlanSelectorComponent {
  @Input() filterPlanIds: number[] = [];
  @Input() multiple: boolean = false;
  @Input() priceMode: boolean = false;
  searchTerm: string = '';
  plans: Plan[] = [];
  filteredPlans: Plan[] = [];
  selectedPlans: Plan[] = []
  currentPrice:number = 0;
  @Output() selectedPlansChange = new EventEmitter<{plans: Plan[], price: number}>();


  constructor(
    public plansDataService: PlansService
  ) {
    effect(() => {
      const plans = this.plansDataService.allPlansData();
      console.log('plans in selector', plans.length);
      if(plans.length > 0) {
        this.filterAndSortPlans(plans);
      }
    });
  }

  getPlans() {
    return this.filteredPlans.filter(plan => !this.filterPlanIds.includes(plan.PlanID));
  }

  filterAndSortPlans(plans: Plan[]) {
    this.plans = plans.sort((a, b) => a.PlanName.localeCompare(b.PlanName));
    this.filteredPlans = this.plans;
  }

  filterTest() {
    console.log('filterTest', this.searchTerm);
  }

  filterPlans() {
    const term = this.searchTerm;
    if(term && term.length > 0) {
      this.filteredPlans = this.plans.filter(plan => plan.PlanName.toLowerCase().includes(term.toLowerCase()));
    } else {
      this.filteredPlans = this.plans;
    }
  }

  onSelectPlans() {
    this.selectedPlansChange.emit({plans: this.selectedPlans, price: this.currentPrice});
  }
}